export default function(obj, prop) {
    Object.defineProperty(obj, prop, { writable: false })
};
